<template>
  <CContainer fluid>
    <CRow>
      <CCol lg="3">
        <CWidgetProgressIcon
            color="s3turquoise"
            text="Prospectos Periodo"
            :value="0"
            :header="`${prospectsCount}`">
            <template #progress>
              &nbsp;
            </template>
            <span class="small text-s3turquoise mr-2">{{ prospectsCount }}</span>
            <i class="bi bi-person-exclamation text-s3turquoise h1"></i>
        </CWidgetProgressIcon>                                
      </CCol>
      <CCol lg="3">
        <CWidgetProgressIcon
            color="s3turquoise"
            text="Oportunidades"
            :value="0"
            :header="`$${formatter.format(opportunitiesValues, 2)}M`">
            <template #progress>
              &nbsp;
            </template>
            <span class="small text-s3lime mr-2">{{ opportunitiesCount }}</span>
            <i class="bi bi-graph-up-arrow text-s3lime h1"></i>
        </CWidgetProgressIcon>                                
      </CCol>
      <CCol lg="3">
        <CWidgetProgressIcon
            color="s3turquoise"
            text="Visitas Periodo"
            :value="0"
            :header="`${visitsCount}`">
            <template #progress>
              &nbsp;
            </template>
            <span class="small text-s3turquoise mr-2">{{ visitsCount }}</span>
            <i class="bi bi-person-exclamation text-s3turquoise h1"></i>
        </CWidgetProgressIcon>                                
      </CCol>
    </CRow>

    <div class="metro-menu mb-3">
      <div 
        class="tile small bg-s3bluemedium" 
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/campanias` })">
        <i class="bi bi-rocket-takeoff"></i>
        <span>Campa&ntilde;as</span>
      </div>
      <div 
        class="tile small bg-s3turquoise" 
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/prospectos` })">
        <i class="bi bi-person-exclamation"></i>
        <span>Prospectos</span>
      </div>
      <div 
        class="tile small bg-s3lime"
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/oportunidades` })">
        <!-- <i class="bi bi-graph-up-arrow"></i> -->
        <i class="bi bi-cloud-sun"></i>
        <span>Oportunidades</span>
      </div>
      <div 
        class="tile small bg-s3taillight"
        @click="$router.push({ path: `/${rootPath}/coming-soon` })">
        <i class="bi bi-person-rolodex"></i>
        <span>Visitas</span>
      </div>
      <!-- <div 
        class="tile small bg-s3orange"
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/seguimientos` })">
        <i class="bi bi-chat-square-text"></i>
        <span>Seguimientos</span>
      </div> -->
      <div 
        class="tile small bg-s3rose"
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/calendarioactividades` })">
        <i class="bi bi-calendar3"></i>
        <span>Calendario Actividades</span>
      </div>
      <div 
        class="tile small bg-s3purple"
        @click="$router.push({ path: `/${rootPath}/movimientos/mercadeo/pipelineventas` })">
        <i class="bi bi-clipboard-data"></i>
        <!-- <i class="bi bi-filter-square"></i> -->
        <!-- <i class="bi bi-funnel"></i> -->
        <span>Dashboard Mercadeo</span>
      </div>
      <!-- <a href="#" @click="$router.push({ path: '/sinacceso'})">
        <span>Accesso Denegado</span>
      </a> -->
    </div>
  </CContainer>
</template>

<script>
  import moment from "moment";

  import { formatter } from "@/general";
  import { 
    dataProspectos,
    dataOportunidades 
  } from "@/apis/marketing";

  export default {
    name: "MarketingMenu",
    components: {
    },
    data() {
      return {
        formatter,
        rootPath: "",
        startDate: "",
        endDate: "",
        prospectsCount: 0,
        opportunitiesCount: 0,
        opportunitiesValues: 0,
        visitsCount: 0
      }
    },
    methods: {
      moment,
      async fetchCounts() {
        try {
          // Prospects
          try {
            const parameters = { 
              "Fecha_Inicial": this.startDate,
              "Fecha_Final": this.endDate,
              "Tipo_Reporte": "RT"
            };
            const { Cantidad } = await dataProspectos(this, 1, "", parameters);

            this.prospectsCount = Cantidad ? Cantidad : 0;
          } catch (e) {
            console.error('Error cargando prospectos', e);
          }

          // Opportunities
          try {
            const parameters = { 
              "Fecha_Inicial": this.startDate,
              "Fecha_Final": this.endDate,
              "Tipo_Reporte": "RT"
            };
            const { Cantidad, Valores } = await dataOportunidades(this, 1, "", parameters);

            this.opportunitiesCount = Cantidad ? Cantidad : 0;
            this.opportunitiesValues = Valores ? (Valores / 1000000) : 0;
          } catch (e) {
            console.error('Error cargando oportunidades', e);
          }

          // // Visits (seguimientos)
          // try {
          //   const { dataGridSeguimientos } = await import('@/apiDataGrids');
          //   const { count } = await dataGridSeguimientos(this, filtersCommon, 1, "");
          //   this.visitsCount = count ? count : 0;
          // } catch (e) {
          //   console.error('Error cargando visitas', e);
          // }
        } catch (err) {
          console.error(err);
        }
      }
    },
    async mounted() {
      this.rootPath = this.$router.currentRoute.fullPath.split("/")[1];

      this.startDate = moment().startOf("month").format("YYYY-MM-DD");
      this.endDate = moment().format("YYYY-MM-DD");

      this.fetchCounts();
    }
  }
</script>
